<div class="content-wrapper container-xxl p-0">
    <div class="content-body" [ngClass]="{ 'center-card': !this.currentUser?.userId }">
      <div class="zeraki-surface-card m-1 m-md-0">
          <div class="row">
            <div class="col-12">
              <div class="holder-container d-flex align-items-center flex-column mx-auto"
                   [ngClass]="{ 'holder-container-logged': this.currentUser?.userId }">
                
                <!-- Contest Details -->
                <ng-container *ngIf="contest && contest.contestId; else showFormOrError">
                  <div class="select-title p-2 d-md-flex text-center text-md-left align-items-center justify-content-between">
                    <img src="../../../../../assets/img/Group 40086.png" alt="" height="108px" class="mb-1 mb-md-0" />
                    <div class="ml-md-2">
                      <p class="mb-1">You are about to join a <span>{{ contest.title }} {{ contest.difficultyLevel }} Quiz</span></p>
                      <p class="mb-0 contest-details">Form {{ contest.form }}, {{ contest.subject }} - {{ contest.title }}</p>
                      <p class="font-small-4 mb-0 font-weight-bold" *ngIf="contest.startDate">Contest Time: {{ contest.startDate | customDate }}</p>
                    </div>
                  </div>
                  <!-- Form (disabled) -->
                  <form [formGroup]="joinContestForm" class="mt-3">
                    <div class="form-group mb-1">
                      <label for="code">Contest Code</label>
                      <input id="code" type="text" class="form-control" formControlName="code" disabled />
                    </div>
                    <div class="form-group mb-1">
                      <label for="displayName">Name</label>
                      <input id="displayName" type="text" class="form-control" formControlName="displayName" disabled />
                    </div>
                  </form>
                  <!-- Join Contest Button -->
                  <button class="btn btn-primary btn-block mt-2 mb-4" (click)="joinContest()" [disabled]="isJoiningContest">
                    <ng-container *ngIf="isJoiningContest; else joinLabel">
                      <span class="spinner-border spinner-border-sm ml-md-1"></span> Joining Contest
                    </ng-container>
                    <ng-template #joinLabel>Join Contest</ng-template>
                  </button>
                </ng-container>
  
                <!-- Form or Error Handling -->
                <ng-template #showFormOrError>
                  <ng-container *ngIf="showErrorMessage; else showForm">
                    <!-- Error Message -->
                    <div class="select-title p-2 d-md-flex text-center text-md-left align-items-center justify-content-between">
                      <img src="../../../../../assets/img/Group 40086.png" alt="" height="108px" class="mb-1 mb-md-0" />
                      <div class="ml-md-2">
                        <p class="mb-0">{{ errorMessage }}</p>
                      </div>
                    </div>
                    <button class="btn btn-primary btn-block mt-5 mb-2" (click)="showJoinContestForm()">Back</button>
                  </ng-container>

                  <!-- Form -->
                  <ng-template #showForm>
                    <div class="select-title p-2 d-md-flex text-center text-md-left align-items-center justify-content-between" [ngClass]="{ 'select-title': this.currentUser?.userId }">
                      <img src="../../../../../assets/img/Group 40086.png" alt="" height="108px" class="mb-1 mb-md-0"/>
                      <div class="ml-md-2">
                        <p class="mb-0">Enter Contest Code to proceed</p>
                      </div>
                    </div>
                    <form [formGroup]="joinContestForm" class="mt-3">
                      <div class="text-danger" *ngIf="submitted && f.errors">
                        <p class="mb-0" *ngIf="f.errors?.required">Please provide contest code</p>
                      </div>
                      <div class="form-group mb-1">
                        <label for="code">Enter Code</label>
                        <input id="code" type="text" class="form-control" placeholder="123q4" formControlName="code" />
                      </div>
                      <div class="form-group mb-1">
                        <label for="displayName">Enter Name</label>
                        <input id="displayName" type="text" class="form-control" placeholder="John Doe" formControlName="displayName" />
                      </div>
                    </form>
                    <!-- Proceed to Contest Button -->
                    <button class="btn btn-primary btn-block mt-2" (click)="getContestByCode()" [disabled]="isGettingContestDetails">
                      <ng-container *ngIf="isGettingContestDetails; else proceedLabel">
                        <span class="spinner-border spinner-border-sm ml-md-1"></span> Fetching Contest Details
                      </ng-container>
                      <ng-template #proceedLabel>Proceed To Contest</ng-template>
                    </button>
                    <button class="btn btn-outline-primary btn-block mt-2 mb-2" routerLink="/beewiz">Back</button>
                  </ng-template>
                </ng-template>
                
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
